import './layout.pcss';
import angular from 'angular';
import 'angular-i18n/angular-locale_hu-hu';
import '../../common/common';
import 'slick-carousel/slick/slick.min';
import 'angular-slick-carousel';
import 'angular-recaptcha';
import 'angularjs-slider';
const MODULE_NAME = 'AADAT-app';
export default angular.module(MODULE_NAME, window.dependencies).name;
window.ipEventBus.subscribe('initAngularApp', () => {
    const element = document.querySelector('[data-layout-id-angular=' + MODULE_NAME + ']');
    angular.bootstrap(element, [MODULE_NAME]);
}, true);

